<div class="oiq-ui-dialog">
  <header>
    <div class="__title">
      <div>
        <h2>Attachment Files for Funding</h2>
        <p>Upload your document for optical character recognition (OCR).</p>
      </div>
      <button (click)="close()" class="oiq-button oiq-button--link __close" type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>
  <main class="flex w-full flex-row gap-0" style="padding: 0">
    @let _selectionList = attachments.selectionList();
    <div class="flex min-w-[40rem] flex-grow flex-col gap-6 pt-6">
      <div class="px-4">
        <div class="mb-4 flex items-center gap-2 rounded bg-gray-1 p-4">
          <div class="flex items-center gap-2 text-white">
            <span class="ph ph-warning text-lg"></span>
            <span class="font-medium">Please Advise</span>
          </div>
          <div class="ml-10 border-l border-r-white pl-10">
            <p class="text-xs font-thin text-gray-3">
              At this stage You need to select
              <b class="font-medium text-white">ONLY Credit Application Document.</b><br />OCR for
              <b class="font-medium text-white">Bank Statements</b> is used in Underwriting
            </p>
          </div>
        </div>
      </div>

      <!-- Upload Area -->
      <oiq-attachments-upload
        class="block flex-grow px-4"
        [filesTableColumns]="['fileName', 'actions']"
        [uploadUrl]="uploadUrl"
        [showChildren]="false"
        [canSelect]="true"
        [canView]="true"
        [canRunOcr]="false"
        selectionMode="ocr"
        [selectMulti]="false"
        layout="vertical">
      </oiq-attachments-upload>

      <!-- Dialog Actions -->
      <div class="flex justify-end gap-x-2 border-t border-gray-4 p-4">
        <button class="oiq-button oiq-button--outline" (click)="close()">Cancel</button>
        <button class="oiq-button oiq-button--primary--outline" (click)="onManually()">
          Create Manually
        </button>
        <button
          class="oiq-button oiq-button--primary--solid"
          [disabled]="!_selectionList.length || attachments.ocrProcessing()"
          (click)="onUsingOcr()">
          {{ attachments.ocrProcessing() ? 'Processing OCR...' : 'Create Using OCR' }}
        </button>
      </div>
    </div>

    <!-- Preview Column -->
    @let _processableList = attachments.ocrRunnableList(); @if (_processableList.length > 0) {
    <div class="preview-column w-[30rem] bg-gray-150 p-4">
      <oiq-image-preview-zoom [attachments]="attachments.viewingList()" [enableZoom]="true">
      </oiq-image-preview-zoom>
    </div>
    }
  </main>
</div>
